import React, { useRef } from "react";
import { FormGroup, InputGroup, Button, Tooltip } from "@blueprintjs/core";
import DefaultToaster from "../../../atoms/DefaultToaster";

export default function CopyLinkTab({ videoId }) {
  const videoUrl = `${process.env.REACT_APP_WEB_URL}/watch/${videoId}`;
  const inputRef = useRef(null);

  function selectAllText() {
    if (!inputRef.current) return;
    inputRef.current.select();
  }

  function copyToClipboard() {
    selectAllText();
    document.execCommand("copy");

    DefaultToaster.show({
      message: "Video link copied to clipboard.",
      icon: "tick-circle",
      timeout: 1000
    });
  }

  return (
    <div>
      <FormGroup
        label="URL"
        helperText="Copy and paste this URL to share the video."
      >
        <InputGroup
          defaultValue={videoUrl}
          inputRef={inputRef}
          onClick={selectAllText}
          rightElement={
            <Button small minimal icon="clipboard" onClick={copyToClipboard} />
          }
        />
      </FormGroup>
    </div>
  );
}
